import React from "react";
import styles from "./products_list.module.css";
import { getArrayCategoriesWithProducts } from "../../utils/util_functions";
import { useSelector } from "react-redux";
import { getCategories } from "../../services/selectors";
import { Link, useLocation } from "react-router-dom";
import ProductCard from "../product_card/product_card";


const SaleNewList = ({ actualProducts }) => {

  const { categories } = useSelector(getCategories);

  const handleClickCategory = (e) => {
    e.currentTarget.closest('li').querySelector('ul').classList.toggle(styles.listHidden);
  }

  const location = useLocation();

  return (
    <ul className={styles.categoriesList}>
      {getArrayCategoriesWithProducts(actualProducts, categories).map(item => {
        return (
          <li key={item.categorySlug} className={styles.item}>
            <p className={styles.category} onClick={handleClickCategory}>
              {item.categoryName} ({item.products.length})
            </p>
            <ul className={`${location.pathname === '/catalog/sale' ? styles.listSale : styles.listNew} ${styles.listHidden}`}>
              {item.products.map(product =>
                <li key={product.id}>
                  <Link to={product.path}
                    className={styles.productCard}
                  >
                    <ProductCard product={product} />
                  </Link>
                </li>
              )}
            </ul>
          </li>
        )
      })}
    </ul>
  );
}

export default SaleNewList;
